<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-popup
      class="holamundo"
      :title="titleSideBar"
      :active.sync="modalForm"
      @close="closeModais"
    >
      <FormProduto :dados="dadosSideBar" @concluido="concluido"></FormProduto>
    </vs-popup>

    <vs-row class="flex flex-row-reverse mb-2">
      <vs-input
        size="large"
        class="border-none"
        name="search"
        id="search"
        v-model="searchQuery"
        placeholder="Pesquisar"
        icon-pack="feather"
        icon="icon-search"
        icon-no-border
      />
    </vs-row>

    <vs-table
      noDataText="Nenhum Produto Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      :max-items="itemsPerPage"
      :data="itensFiltred"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="inativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="reativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                v-if="$can($actionsDefault.Exportar, subjectPermission)"
              >
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="produtos.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>

          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium"
            >
              <span class="mr-2">Filtrar por:</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="filtrar('Ativos')">
                <span>Ativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Inativos')">
                <span>Inativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Todos')">
                <span>Todos</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!------------ START ADD NOVO Produto ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openModalInsertEdit({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar novo Produto</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Produto ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                count - paginaAtual * itemsPerPage > 0
                  ? paginaAtual * itemsPerPage
                  : count
              }}
              de {{ count }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="Nome">Id</vs-th>
        <vs-th sort-key="Nome">Produto</vs-th>
        <vs-th sort-key="Produto">Grupos</vs-th>
        <vs-th sort-key="Produto">Formas de Pagamento</vs-th>
        <vs-th sort-key="Produto">Obrigatório</vs-th>
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.idProduto }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.nomeProduto }}</p>
            </vs-td>

            <vs-td>
              <TruncateList :items="tr.Grupos" :maxItems="3" />
            </vs-td>

            <vs-td>
              <vs-list-item
                v-for="item in tr.TipoPagamento"
                :key="item.id"
                :subtitle="item.nomePagamento"
              ></vs-list-item>
            </vs-td>

            <vs-td>
              <p class="product-category">
                {{ getObrigatorioString(tr.obrigatorio) }}
              </p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusString(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p class="product-price">
                <vs-button
                  radius
                  v-tooltip="'Detalhes'"
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  class="d-inline"
                  @click="openModal(tr.idProduto)"
                ></vs-button>
                <vs-button
                  radius
                  v-tooltip="'Editar'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="openModalInsertEdit(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="pages" :max="7" v-model="paginaAtual" />
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO Produto ------------>
    <ModalInfoProduto
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados do ${entidade}`"
      @close="popupActive = false"
    ></ModalInfoProduto>
    <!------------ END INFORMAÇÕES DO Produto ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from './../Includes/SideBar';
import service from '../../services';
import downloadexcel from 'vue-json-excel';
import ModalInfoProduto from '../../components/ModalInfoProduto';
import FormProduto from '../forms/FormProduto.vue';
import TruncateList from '../../components/list/TruncateList.vue';
import debounce from 'lodash/debounce';

export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfoProduto,
    FormProduto,
    TruncateList,
  },
  props: ['subjectPermission'],
  data() {
    return {
      idEmpresa: null,
      modalForm: false,
      dadosSideBar: {},
      controllerGeral: 'Produto',
      formSideBar: 'Produto',
      entidade: 'Produto',
      titleSideBar: 'Adicionar Produto',
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      itensFiltred: [],
      ultimoFiltro: 'Todos',
      colunas: {},
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      paginaAtual: 1,
      pages: 0,
      count: 0,
      searchQuery: '',
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    closeModais() {
      this.modalForm = false;
    },
    filtrar(por) {
      this.ultimoFiltro = por;
      if (por == 'Todos') this.itensFiltred = this.itens;
      if (por == 'Ativos')
        this.itensFiltred = this.itens.filter((x) => x.deletedAt == null);
      if (por == 'Inativos')
        this.itensFiltred = this.itens.filter((x) => x.deletedAt != null);
    },
    inativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idProduto);
        });
        service
          .post(this.controllerGeral, 'Inativar', { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Registro inativado(s) com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione pelo menos um registro',
          color: 'danger',
        });
      }
    },
    reativar() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idProduto);
        });
        service
          .post(this.controllerGeral, 'Reativar', { ids: ids })
          .then((res) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Registro reativado(s) com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione pelo menos um registro',
          color: 'danger',
        });
      }
    },
    buscaDados(
      paginaAtual = null,
      itemsPerPage = null,
      searchQuery = undefined,
    ) {
      if (paginaAtual != null) this.paginaAtual = paginaAtual;
      if (itemsPerPage != null) this.itemsPerPage = itemsPerPage;

      this.selected = [];
      this.$vs.loading();
      service
        .getAll(
          this.controllerGeral,
          {},
          `listPaginated/${this.paginaAtual}/${this.itemsPerPage}/idEmpresa=${
            this.idEmpresa
          }${searchQuery ? `?query=${searchQuery}` : ''}`,
        )
        .then(({ data }) => {
          this.itens = [];
          this.itensFiltred = [];

          const { rows, pages, count } = data;
          this.count = count;
          this.pages = pages;

          rows.forEach((element) => {
            let arrAux = [];
            let arrAux2 = [];
            let arrAux3 = [];

            if (element.Produtos_Grupos)
              element.Produtos_Grupos.forEach((el) => {
                let obj = {
                  idGrupo: el.idGrupo,
                  idProduto: el.idProduto,
                  idProdutoGrupo: el.idProdutoGrupo,
                  nomeGrupo: el.Produtos_grupos
                    ? el.Produtos_grupos.nomeGrupo
                    : '',
                  valor: el.valor,
                };
                arrAux.push(obj);
              });

            if (element.Produtos_TipoPagamento)
              element.Produtos_TipoPagamento.forEach((el) => {
                let obj = {
                  idTipoPagamento: el.TipoPagamento_Empresa
                    ? el.TipoPagamento_Empresa.idTipoPagamento
                    : null,
                  nomePagamento: el.TipoPagamento_Empresa
                    ? el.TipoPagamento_Empresa.TipoPagamento_domTipoPagamento
                        .nomePagamento
                    : null,
                  idTipoPagamentoEmpresa: el.idTipoPagamentoEmpresa,
                  idProdutoTipoPagamento: el.idProdutoTipoPagamento,
                };
                arrAux2.push(obj);
              });

            if (element.Produtos_Descontos)
              element.Produtos_Descontos.forEach((el) => {
                let obj = el;
                arrAux3.push(obj);
              });

            element.Grupos = arrAux;
            element.TipoPagamento = arrAux2;
            element.ProdutosDescontos = arrAux3;

            delete element.Produtos_Grupos;
            delete element.Produtos_Descontos;
            delete element.Produtos_TipoPagamento;

            this.itens.push(element);
          });

          this.itensFiltred = [...this.itens];
          this.filtrar(this.ultimoFiltro);
          //this.itens = res.data;
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != 'createdAt' &&
                element != 'updatedAt' &&
                element != 'deletedAt' &&
                element.indexOf('id') != 0
              ) {
                this.colunas[element] = element;
              }
            });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    openModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idProduto == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    openModalInsertEdit(dados) {
      const { idProduto } = dados;

      !idProduto
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do ${this.entidade}`);

      this.dadosSideBar = dados;

      this.modalForm = true;
    },
    concluido() {
      this.modalForm = false;
      this.buscaDados(this.paginaAtual, this.itemsPerPage, this.searchQuery);
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    getObrigatorioString(data) {
      if (data == null || data == false) return 'Não';
      return 'Sim';
    },
    async search() {
      if (this.searchQuery.length >= 3) {
        try {
          await this.buscaDados(
            this.paginaAtual,
            this.itemsPerPage,
            this.searchQuery,
          );

          this.paginaAtual = 1;
        } catch (e) {
          console.log(e);
        }
      } else if (this.searchQuery.length == 0) {
        this.buscaDados();
      }
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
  watch: {
    paginaAtual() {
      this.buscaDados(this.paginaAtual);
    },
    itemsPerPage() {
      this.buscaDados(null, this.itemsPerPage);
    },
    searchQuery: {
      handler: debounce(function (newValue) {
        // Your debounced logic here
        this.search();
      }, 300), // Adjust the debounce wait time (in milliseconds) as needed
    },
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<!------------ END STYLE ------------>
